import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { Text } from "../../../components/Text";
import { EntryKind } from "../../../model/entry/types/EntryKind.enum";
import { Spacing } from "../../../theme/Spacing";
import { ThemeType } from "../../../theme/Theme";
import { Badge } from "./DuplicateCardPrimitives";

const KIND_BACKGROUND: Record<EntryKind, keyof ThemeType> = {
  [EntryKind.LEAD]: "lead",
  [EntryKind.CONTACT]: "contact",
  [EntryKind.JUNK]: "junk",
};

const KIND_TEXT_COLOR: Record<EntryKind, keyof ThemeType> = {
  [EntryKind.LEAD]: "onLead",
  [EntryKind.CONTACT]: "onContact",
  [EntryKind.JUNK]: "onJunk",
};

const CountPart = styled.span`
  align-self: stretch;
  display: flex;
  align-items: center;
  margin-inline-end: -${Spacing.s};
  padding-inline: ${Spacing.s};
  font-weight: bold;
`;

type Props = { kind: EntryKind; count?: number };

export const EntryKindBadge: React.FC<Props> = ({ kind, count }) => {
  const { t } = useTranslation();

  return (
    <Badge $tone={KIND_BACKGROUND[kind]}>
      <Text fontSize="xs" fontWeight="bold" color={KIND_TEXT_COLOR[kind]}>
        {t(`common.${kind.toLowerCase()}`)}
      </Text>
      {Number.isFinite(count) ? (
        <CountPart>
          <Text fontSize="xs" fontWeight="bold" color={"white"}>
            {count}
          </Text>
        </CountPart>
      ) : null}
    </Badge>
  );
};
